<template>
  <div class="col-12 col-lg-7 col-xl-8 mb-3">
    <v-dialog
      v-model="dialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h6 text-center">
          {{ dialog_message }}
        </v-card-title>

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="green darken-1"
            text
            @click="(dialog = false), (deldigit = false)"
          >
            ยกเลิก
          </v-btn>

          <v-btn
            color="red darken-1"
            text
            @click="(dialog = false), specialButtonDel()"
          >
            ยืนยัน
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <form
      id="shoot"
      method="POST"
      class="w-100"
      @submit.prevent="onSubmit"
    >
      <div class="d-flex">
        <div class="flex-width">
          <div class="form-group">
            <input
              v-model="digitValue"
              required="required"
              name="digit"
              disabled="disabled"
              class="form-control text-center text-lg disabled"
              type="tel"
              :placeholder="placeHolder"
              :maxlength="digitValueSet"
              :minlength="digitValueSet"
              @keypress="validateNumber($event)"
              @paste="onPaste($event)"
            >
          </div>
        </div>
      </div>

      <div class="d-flex">
        <div class="flex-width my-1">
          <button
            type="button"
            class="btn btn-yellow w-100"
            @click="digitClick(1)"
          >
            1
          </button>
        </div>
        <div class="flex-width mx-1 my-1">
          <button
            type="button"
            class="btn btn-yellow w-100"
            @click="digitClick(2)"
          >
            2
          </button>
        </div>
        <div class="flex-width my-1">
          <button
            type="button"
            class="btn btn-yellow w-100"
            @click="digitClick(3)"
          >
            3
          </button>
        </div>
      </div>
      <div class="d-flex">
        <div class="flex-width my-1">
          <button
            type="button"
            class="btn btn-yellow w-100"
            @click="digitClick(4)"
          >
            4
          </button>
        </div>
        <div class="flex-width mx-1 my-1">
          <button
            type="button"
            class="btn btn-yellow w-100"
            @click="digitClick(5)"
          >
            5
          </button>
        </div>
        <div class="flex-width my-1">
          <button
            type="button"
            class="btn btn-yellow w-100"
            @click="digitClick(6)"
          >
            6
          </button>
        </div>
      </div>
      <div class="d-flex">
        <div class="flex-width my-1">
          <button
            type="button"
            class="btn btn-yellow w-100"
            @click="digitClick(7)"
          >
            7
          </button>
        </div>
        <div class="flex-width mx-1 my-1">
          <button
            type="button"
            class="btn btn-yellow w-100"
            @click="digitClick(8)"
          >
            8
          </button>
        </div>
        <div class="flex-width my-1">
          <button
            type="button"
            class="btn btn-yellow w-100"
            @click="digitClick(9)"
          >
            9
          </button>
        </div>
      </div>
      <div class="d-flex">
        <div class="flex-width my-1">
          <button
            type="reset"
            class="btn btn-dark w-100"
            @click="digitClear()"
          >
            ลบ
          </button>
        </div>
        <div class="flex-width mx-1 my-1">
          <button
            type="button"
            class="btn btn-yellow w-100"
            @click="digitClick(0)"
          >
            0
          </button>
        </div>
        <div class="flex-width my-1">
          <button
            type="submit"
            class="btn btn-dark w-100"
            @click="pushDigit"
          >
            เพิ่ม
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
export default {
  name: 'BetSet',
  props: {
    lottoNumbersWithType: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      title: 'หวยชุด',
      currentDigit: 0,
      currentVal: '',
      dialog_message: '',
      dialog: false,
      delVal: '',
      digitValue: '',
      digitValueSet: 4,
      placeHolder: 'กรอกเลข 4 หลัก',
      shuffleDigit: false,
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    handlePosition(evt, position) {
 

      if (!evt.target.value) {
        this.focusNext(position - 1);
      } else {
        this.focusNext(position + 1);
      }
    },
    focusNext(val) {
      if (val < 0) {
        val = 0;
      }
      if (val > 3) {
        val = 3;
      }
      document.getElementById(val).focus();
    },
    validateNumber(evt) {
      evt = evt || window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31
        && (charCode < 48 || charCode > 57)
        && charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    onPaste(evt) {
      evt.preventDefault();
    },
    digitClick(eValue) {
      if (this.digitValue.length < this.digitValueSet) {
        this.digitValue += eValue;
      } else {
        this.digitValue = '';
        this.digitValue += eValue;
      }
    },
    specialButtonDel() {
      this.$emit('child-digitClickSet', this.delVal);
    },
    digitClear() {
      this.digitValue = '';
    },
    onSubmit(e) {
      e.preventDefault();
    },
    onPaste(evt) {
      evt.preventDefault();
    },
    validateNumber(evt) {
      evt = evt || window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31
        && (charCode < 48 || charCode > 57)
        && charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    startConvertType() {
      this.digitValue = '';
      this.digitValueSet = 4;
      this.placeHolder = 'ระบุเลข 4 หลัก';
    },
    pushDigit() {
      let countSearch = 0;
      const val = this.digitValue;

      if (val.length == 4) {
        const search1 = this.lottoNumbersWithType.filter(
          (item) => item.digits == val && item.type == '4upper',
        );
        countSearch = search1.length;

        if (countSearch < 1) {
          this.$emit('child-digitClickSet', val);
          Vue.$toast.open({
            message: `เพิ่มเลข ${val} สำเร็จ`,
            type: 'success',
            duration: 1000,
            position: 'top-right',
            dismissible: true,
          });
          this.digitValue = '';
        } else {
          this.$set(this, 'dialog', true);
          this.$set(this, 'dialog_message', `ต้องการลบเลข ${val}`);
          this.$set(this, 'delVal', val);
          this.digitValue = '';

          // this.$emit("child-digitClickSet", val);
        }
      }
    },
  },
};
</script>
